// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"155":"288ee6ed","188":"df37d812"}[chunkId] + ".css";
};